"use client";

import { useCarouselButtons } from "@repo/lib/hooks/common";
import { useDotButton } from "@repo/lib/hooks/common";
import { Link } from "@/i18n/routing";
import { IconLinkArrow } from "@repo/assets/images";
import { CarouselButton, DotButton, PageTitle } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import cx from "classnames";
import useEmblaCarousel from "embla-carousel-react";
import { useLocale } from "next-intl";
import Image from "next/image";
const Collections = ({
  data
}) => {
  const {
    title,
    slides,
    link,
    contentPosition,
    Card: ItemCard
  } = data;
  const locale = useLocale();
  const isRTL = locale === "ar";
  const OPTIONS = {
    slidesToScroll: 1,
    loop: true,
    direction: isRTL ? "rtl" : "ltr",
    align: "start"
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = useCarouselButtons(emblaApi);
  const {
    selectedIndex,
    scrollSnaps,
    onDotButtonClick
  } = useDotButton(emblaApi);
  const isCarouselRequired = ItemCard?.length > 1;
  const isItemCountLessThanSlides = ItemCard?.length <= Number(slides || 3);
  return <section className="px-4 py-5 md:py-8" data-sentry-component="Collections" data-sentry-source-file="Collections.jsx">
      <div className="mx-auto md:max-w-screen-xl">
        {(title || link) && <div className="mb-5 flex items-center justify-between md:mb-9">
            {title && <PageTitle title={title} as="h2" className="rtl:font-arabic" variant="medium" />}
            {link && link.icon?.url && <Link href={link.url || "/"} target={link.newTab ? "_blank" : undefined} rel={link.newTab ? "noopener noreferrer" : undefined} className="group inline-flex items-center transition-all duration-300 hover:translate-x-1 rtl:hover:-translate-x-1">
                <IconLinkArrow className="text-icon-color size-6 fill-current transition-all duration-300 group-hover:translate-x-2 rtl:rotate-180 rtl:group-hover:-translate-x-2" />
              </Link>}
          </div>}

        <div className="mx-auto w-full overflow-hidden md:max-w-[90vw]" ref={isCarouselRequired ? emblaRef : null}>
          <div className="flex flex-row gap-0">
            {ItemCard?.map(item => {
            const {
              media,
              title,
              subText,
              url,
              urlText
            } = item;
            if (!item?.media?.url) return null;
            return <div className={cx(`flex-collection-sm md:flex-collection-md h-full w-full min-w-0`, {
              "p-2": contentPosition === "overlay" || !contentPosition,
              "p-1.5": contentPosition === "bottom"
            })} key={item?.id}>
                  <Link href={url || "/"}>
                    {/* card */}
                    <div className="group max-h-full">
                      <div key={item?.id} className="relative min-h-full">
                        {media?.url && <div className="shadow-gray/10 rounded-collection-card group isolate h-full overflow-hidden shadow-lg">
                            <Image src={getStrapiMedia(media?.url)} alt={title || media?.alternativeText || ""} width={media?.width} height={media?.height} className="mx-auto me-0 aspect-auto h-full max-h-[432px] min-h-44 object-cover transition-all duration-500 ease-in-out will-change-transform md:group-hover:scale-110 lg:min-h-60 rtl:-scale-x-100 rtl:md:group-hover:-scale-x-110" />
                          </div>}

                        <div className={cx("flex h-full max-h-fit", {
                      "absolute inset-0": contentPosition === "overlay" || !contentPosition,
                      "mt-2": contentPosition === "bottom"
                    })}>
                          <div className={cx("text-primarygray flex flex-col", {
                        "size-full justify-between p-4": contentPosition === "overlay" || !contentPosition,
                        "gap-2": contentPosition === "bottom"
                      })}>
                            <div>
                              {subText && <p className="text-primarygray text-xs font-medium md:text-sm">
                                  {subText}
                                </p>}
                              {title && <h2 className={cx("font-heading text-primarygray rtl:font-arabic mt-1 text-xl font-normal leading-tight md:text-2xl md:portrait:text-lg", {
                            "max-w-[75%]": contentPosition === "overlay" || !contentPosition,
                            "max-w-full": contentPosition === "bottom"
                          })}>
                                  {title}
                                </h2>}
                            </div>
                            {url && urlText && <div className="text-primarygray inline-flex items-center gap-2 text-sm font-medium">
                                {urlText}
                                <IconLinkArrow className="text-icon-color size-3 fill-current rtl:rotate-180" />
                              </div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>;
          })}
          </div>
        </div>

        {isCarouselRequired && <div className={cx("mx-auto mt-6 px-4 sm:px-0 md:mt-4", {
        "md:hidden": isItemCountLessThanSlides
      })}>
            <div className="relative h-6 md:h-8">
              <div className={cx("absolute inset-0 flex items-center justify-center gap-2", {
            "md:hidden": isItemCountLessThanSlides
          })}>
                {scrollSnaps.map((_, index) => <DotButton key={index} onClick={() => onDotButtonClick(index)} className={cx("h-2 w-2 rounded-full", {
              "bg-black": index === selectedIndex,
              "bg-[#D4D4D4]": index !== selectedIndex
            })} aria-label={index} />)}
              </div>
              <div className={cx("absolute right-0 top-1/2 hidden -translate-y-1/2 gap-6 md:flex", {
            "md:hidden": isItemCountLessThanSlides
          })}>
                <CarouselButton direction="prev" onClick={onPrevButtonClick} disabled={prevBtnDisabled} className="rounded-full bg-[#F5F3F1] text-black" />
                <CarouselButton direction="next" onClick={onNextButtonClick} disabled={nextBtnDisabled} className="rounded-full bg-[#F5F3F1] text-black" />
              </div>
            </div>
          </div>}
      </div>
    </section>;
};
export default Collections;